import React from "react";
import { useQuery } from "@apollo/client";

import * as OrganizationQL from "queries/organization";
import { LimitsPanel } from "components/statistics/limits/panel";

// The ORGANIZATION's size against its limit.
//
// The same panel a bucket draws, over a different read. The query lives here
// rather than in the panel because the scope is the point: this one is composed
// server-side from the resolved account and carries the {orgId} value id, where
// the bucket read carries {orgId, bucketId} — different fields, different
// guards, and a component that chose between them would be a third place to get
// that wrong.
//
// It is also the row a bucket's screen deliberately throws away. The
// organization limit is declared over orgId alone, so a bucket-scoped read
// matches it too and would render the org's total as that bucket's
// consumption. Here it is the only row that belongs.

const read = (data) =>
  data?.viewer?.account?.organization?.usage?.list || null;

export const Limits = () => {
  const { data, loading, error } = useQuery(OrganizationQL.usage, {
    notifyOnNetworkStatusChange: true,
  });

  return (
    <LimitsPanel
      title={"Organization limits"}
      listing={read(data)}
      loading={loading}
      error={error}
      errorMessage={"Could not read this organization's limits."}
      // Every organization gets one on sign-up (model/organization.initialize),
      // so an empty listing here is a real state rather than an expected one —
      // and it must not read as "no ceiling".
      empty={"No limits are configured for this organization."}
      truncatedMessage={
        "Partial: this organization has more limits than one page holds, so some are not shown."
      }
    />
  );
};

export default Limits;
